<template>
    <div class="users">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">Kullanıcı Ara</label>
                    <div class="input-group">
                        <input class="form-control custom-input" type="text" placeholder="Ad, Soyad, E-mail..." v-model="search">
                        <span class="input-group-btn">
                            <a class="btn btn-primary" style="height: 45px;" @click="getUsers">
                                <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">Kullanıcı Tipi</label>
                    <select class="form-control custom-input" v-model="user_type" @change="getUsers">
                        <option value="">Seçiniz...</option>
                        <option value="1">Yurt</option>
                        <option value="2">Öğrenci</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                            <span>Toplam {{ pagination.total || 0 }} sonuç gösteriliyor.</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>Üyelik Tipi</th>
                                    <th>Ad Soyad</th>
                                    <th>E-mail</th>
                                    <th>İşlemler</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td>{{ (item.type && item.type.type) ? item.type.type : 'Seçilmemiş' }}</td>
                                    <td>{{ item.first_name }} {{ item.last_name }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>
                                        <router-link :to="{ name: 'users.update', params: {id: item.id} }" class="btn btn-primary btn-xs">
                                            <i class="fa fa-edit"></i> <span>Düzenle</span></router-link>
                                        /
                                        <button class="btn btn-danger btn-xs" @click="destroy(item)"><i class="fa fa-trash"></i> Sil
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Pagination from '@/components/layouts/Pagination'
  export default {
    components: { Pagination },
    data() {
      return {
        search: '',
        user_type: '',
        icon: 'fa fa-users',
        tableName: 'Üyeler Tablosu',
        tableDesc: 'Bu tablo sitenizde aktif/pasif olan üyeleri gösterir',
        api: 'users/',
        items: [],
        pagination: {
          'current_page': 1,
          'total': 0
        },
      }
    },

    methods: {
      fetchPosts() {
        this.$Progress.start();
        this.axios.get(this.api, {
          params: {
            page: this.pagination.current_page,
            name: this.search,
            user_type: this.user_type
          }
        }).then(response => {
          this.pagination = response.data.pagination;
          this.items = response.data.data.data;
          // this.items.map(item => {
          //   return item.first_name.toUpperCase();
          // });
          this.$Progress.finish()
        })
        // eslint-disable-next-line no-unused-vars
            .catch(error => {
              this.$Progress.finish()
              // console.log(error.response.data);
            });
      },
      getUsers() {
        this.pagination = {'current_page': 1};
        this.fetchPosts();
      },
      destroy(item) {
        this.$swal({
          title: 'Silmek istediğinizden emin misiniz?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Evet',
          cancelButtonText: 'İptal'
        }).then((result) => {
          if (result.value) {
            this.axios.delete(this.api + item.id).then(response => {
              if (response.status == 200) {
                this.$swal(
                    'Başarılı!',
                    'Veri silme işlemi başarılı',
                    'success'
                );
                this.items.splice(this.items.indexOf(item), 1)
              }
            })
          }
        })
      },
    },
    mounted() {
      this.fetchPosts();
    },
    computed: {
      upperCase() {
        return this.items.map(item => {
          // console.log(item.first_name);
          return item.first_name.toUpperCase();
        });
      }
    },
  }
</script>
